// From System.options.template_qc_categories
export type TemplateQualityControlCategoryModel = {
  id: number,
  key: string,
  title: string,
}

const state = {
  id: null,
  key: '',
  title: '',
}

export const requiredFields = [
  { key: 'key' },
  { key: 'title' },
]

export default state
